<template>
  <div class="c-box-button-group">
    <ul v-if="subjects">
      <li
        v-for="(item, index) in subjects"
        :key="index"
      >
        <c-box-button
          :active="item.active"
          :name="item.name"
          :text="item.text"
          @click="selectSubject"
        />
      </li>
    </ul>
  </div>
</template>

<script>
import CBoxButton from './CBoxButton.vue'
import subject from '../../mixins/subjects'
import { capitalizeFirstLetter } from '../../../../../../../resources/js/helper'
import { mapGetters, mapMutations } from 'vuex'

export default {
  name: 'CBoxButtonGroup',
  components: { CBoxButton },
  mixins: [subject],
  data () {
    return {
      subjectName: 'cpl',
      subjects: {}
    }
  },
  computed: {
    ...mapGetters({
      getSubjectName: 'Subject/getSubjectName'
    })
  },
  mounted () {
    this.subjects = this.getSubjects()
    // Получаем значение из store, если есть
    const subjectName = this.getSubjectName
    if (subjectName) {
      this.subjectName = subjectName
    }
    this.selectSubject(this.subjectName)
  },
  methods: {
    ...mapMutations({
      setSubjectName: 'Subject/setSubjectName'
    }),
    getSubjects () {
      const subjects = {}
      const subjectNames = [
        'cpl',
        'clicks',
        'conversions',
        'shows',
        'costs'
      ]
      subjectNames.forEach(item => {
        subjects[item] = {
          text: (item === 'cpl')
            ? this.getSubjectText(item).toUpperCase()
            : capitalizeFirstLetter(this.getSubjectText(item)),
          name: item,
          active: false
        }
      })
      return subjects
    },
    selectSubject (subjectName) {
      // Деактивируем предыдущую кнопку выбора показателя
      this.subjects[this.subjectName].active = false
      // Назначаем новый показатель
      this.subjectName = subjectName
      // Активируем новую кнопку выбора показателя
      this.subjects[this.subjectName].active = true
      // Пишем в store
      this.setSubjectName(subjectName)
    }
  }
}
</script>

<style scoped lang="scss">
@import '../../../../../../../resources/css/variables';

.c-box-button-group {
  ul {
    margin: 0;
    padding: 0;
    list-style: none;
    & > li {
      margin-bottom: 14px;
      @media all and (max-width: $smBreakpoint - 1) {
        margin-bottom: 10px;
      }
      &:last-child {
        margin-bottom: 0;
      }
    }
  }
}
</style>
